import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';

export interface LinkSmallMegaMenuProps {
  link: {
    title: string;
    url?: string;
    new_filter_experiment_url?: string;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LinkSmallMegaMenu',
  props: {
    link: null
  },
  setup(__props: any) {



const { $isFlagOn } = useContext();

return { __sfc: true,$isFlagOn }
}

})